export default "__VITE_ASSET__Dwt8ZMVq__"